export const svgIcons: string[] = [
  'upload',
  'file-pdf',
  'file-close',
  'around-plus',
  'btn-arrow-white',
  'lang-arrow',
  'share',
  'eye',
  'watch-video',
  'round-info',
  'round-back',
  'copy-icon',
  'arrow-down-long',
  'icon-list',
  'folder-border',
  'folder-red',
  'info',
  'group',
  'lawyer',
  'victim',
  'organizacion',
  'person',
  'flag-ua',
  'search',
  'choose-cripto',
  'round-close',
  'none',
  'union',
  'pdf-file',
  'round-error',
  'round-success',
  'close',
  'around-question',
  'attention',
  'arrow-right',
  'btn-back',
  'red-warning',
  'scammer-icon',
  'icon-usdt',
  'ltc-icon',
  'eth-icon',
  'btc-icon',
  'trx-icon',
  'usdt-icon',
  'around-receipt',
  'recovery-extremely_low',
  'recovery-low',
  'recovery-medium',
  'recovery-high',
  'recovery-extremely_high',
  'icon-status-completed',
  'icon-status-done',
  'icon-invoice',
  'round-bg-plus',
  'invoice-completed',
  'return-round',
  'arrow-right-bold',
  'check-marker-bold',
  'check-marker-in-circle',
  'vector-info',
  'arrow-go-back',
  'check-marker-in-circle-thin-marker',
  'cross-in-circle-with-bg',
  'check-marker-with-bg',
  'trash',
  'arrow-down-long-2',
  'arrow-left',
  'check-marker',
  'reset-icon',
  'attention-filled',
  'round-info-2',
  'attention-circle',
  'loader',
  'zoom-gesture',
  'like-icon',
  'tg-icon-in-circle',
  'long-arrow-right',
  'slim-horizontal-arrow',
];
